import Table from "../components/Table";
import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useEffect, useRef, useState } from "react";
import $ from "jquery";
import config from "../../../config";
import Pagination from "../../../components/Pagination";
import filterIcon from "../../../images/icons/filter.png";
import "../style.css";
import Swal from "sweetalert2";
import moment from "moment";
import Tippy from "@tippyjs/react";
import Filter from "../components/Filter";
import ExcelDownload from "../components/ExcelDownload";
import { millionComma } from "../../../utils";

const NonMovingItems = (props) => {
  const [user, setUser] = useState({});
  const [pageSize, setPageSize] = useState(10);
  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const getBranchList = async (inputValue, callback) => {
    let branches = props.branchList.filter((b) =>
      b.label
        .toString()
        .toLowerCase()
        .includes(inputValue.toString().toLowerCase())
    );
    callback(branches);
  };
  const getGodownList = async (inputValue, callback) => {
    await $.post(
      `${config.apiUrl}/godown/listGodown`,
      JSON.stringify({
        godown_name: inputValue,
        paginate: 0,
        is_active: 1,
        branch_id: filter.branch_id,
      }),
      function (res) {
        if (res?.data?.count) {
          callback(
            res.data.list.map((v) => {
              return {
                value: v.godown_id,
                label: v.godown_name,
              };
            })
          );
        } else {
          callback([]);
        }
      }
    );
  };

  const getItemCatList = async (inputValue, callback) => {
    if (inputValue.toString().length > 2) {
      await $.post(
        `${config.apiUrl}/itemCategory/listItemCategory`,
        JSON.stringify({
          is_active: 1,
          paginate: 0,
          item_cat_name: inputValue.toString(),
        }),
        function (res) {
          callback(
            res.data.list.map((v) => {
              return {
                value: v.item_cat_id,
                label: v.item_cat_name,
              };
            })
          );
        }
      );
    } else {
      callback([]);
    }
  };

  const isMounted = useRef(false);
  let getTransactionType = [
    { value: "1", label: "Purchase" },
    { value: "3", label: "Purchase Return" },
    { value: "2", label: "Challan" },
    { value: "4", label: "Challan Return" },
    { value: "6", label: "Stock In" },
    { value: "5", label: "Stock Out" },
  ];

  const filterList = [
    {
      name: "branch_id",
      label: "Branch Name",
      type: "async_select",
      visible: [1, 2].includes(user.role_id),
      values: getBranchList,
    },
    {
      name: "godown_id",
      label: "Godown Name",
      type: "async_select",
      values: getGodownList,
    },
    {
      name: "item_cat_id",
      label: "Category",
      type: "async_select",
      values: getItemCatList,
    },
    {
      name: "tran_type",
      label: "Transaction Type",
      type: "select-dropdown",
      values: getTransactionType,
    },
    { name: "from_date", label: "From Date", type: "date", required: "true" },
    { name: "to_date", label: "To Date", type: "date", required: "true" },
  ];

  const columnList = [
    {
      label: "Branch Name",
      value: "branch_name",
      visible: [1, 2].includes(user.role_id),
    },
    { label: "Item Name", value: "item_name", visible: true },
    { label: "Category", value: "item_cat_name", visible: true },
    { label: "Godown", value: "godown_name", visible: true },
    {
      label: "Last Transaction Type",
      value: "last_transaction_type",
      visible: true,
    },
    {
      label: "Last Transaction Number",
      value: "last_transaction_number",
      visible: true,
    },
    { label: "Type", value: "tran_type", visible: true },

    {
      label: "Last Transaction Date",
      value: "last_transaction_date",
      visible: true,
    },
  ];

  const [filter, setFilter] = useState(() => {
    let filters = {};
    filterList.forEach((list) => {
      if (list.name === "from_date" || list.name === "to_date") {
        filters[list.name] = moment().format("YYYY-MM-DD");
      } else {
        filters[list.name] = "";
      }
    });
    return filters;
  });
  const [column, setColumn] = useState(() => columnList);
  useEffect(() => {
    setColumn(() => columnList);
    setFilter(() => {
      let filters = {};
      filterList.forEach((list) => {
        if (list.name === "from_date" || list.name === "to_date") {
          filters[list.name] = moment().format("YYYY-MM-DD");
        } else {
          filters[list.name] = "";
        }
      });
      return filters;
    });
  }, [user]);
  const [row, setRow] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [showFilter, setShowFilter] = useState(true);
  const [showLoading, setShowLoading] = useState(false);
  const [totalAmt, setTotalAmt] = useState(0);

  const getList = async () => {
    // if (!filter?.payment_mode_id) {
    //     Swal.fire("Error", "Ledger Name is Required")
    //     return
    // }
    if (!filter?.from_date || !filter?.to_date) {
      Swal.fire("Error", "Date is Required");
      return;
    }
    if (user?.role_id === 3 || user?.role_id === 4) {
      filter.branch_id = JSON.parse(
        localStorage.getItem("inventory")
      )?.userData?.branch_data?.[0]?.branch_id;
    }

    setShowLoading(true);
    await $.post(
      `${config.apiUrl}/report/listNonMovingItems`,
      JSON.stringify({
        ...filter,
        paginate: 1,
        page_no: currentPage - 1,
        page_size: pageSize,
      })
    )

      //     label: "Last Transaction Type",
      //     value: "last_ransaction_type",
      //     visible: true,
      //   },
      //   {
      //     label: "Last Transaction Number",
      //     value: "last_transaction_number",
      //     visible: true,
      //   },
      //   { label: "Type", value: "tran_type", visible: true },

      //   {
      //     label: "Last Transaction Date",
      //     value: "last_transaction_date",
      //     visible: true,
      //   },
      // ];
      .done((res) => {
        if (res?.data?.list?.length > 0) {
          let cols = columnList.map((col) => col.value);
          let total = res?.data?.totalAmount || 0;
          setRow(() => {
            let resArr = res?.data?.list || [];
            let tranType = [
              "Opening",
              "Purchase",
              "Challan",
              "Purchase Rtn",
              "Challan Rtn",
              "Stock Out",
              "Stock In",
              "Closing",
            ];
            let arr = [];
            resArr.forEach((r, i) => {
              arr.push({
                branch_name: r?.branch_name || "",
                item_name: r?.item_name || "",
                item_cat_name: r?.item_cat_name || "",
                godown_name: r?.godown_name || "",
                last_transaction_type: r?.last_transaction_type || "",
                last_transaction_number: r?.last_transaction_number || "",
                tran_type: tranType?.[r?.tran_type] || "",
                tran_id: r?.trans_id,
                last_transaction_date: r?.last_transaction_date
                  ? moment(r?.last_transaction_date)?.format("DD-MM-YYYY")
                  : "-",
              });
            });
            return arr;
          });
          setTotalPage(() => res?.data?.count || 0);
          setCurrentPage(() => currentPage);
          setTotalAmt(total);
        } else {
          setTotalPage(() => 0);
          setCurrentPage(() => 1);
          setRow(() => []);
        }
        setShowLoading(false);
      })
      .fail((err) => {
        Swal.fire(
          "",
          err?.responseJSON?.data?.message || err?.responseJSON?.message
        );
        setTotalAmt(0);
        setShowLoading(false);
      });
  };

  const clearList = () => {
    setFilter(() => {
      let filters = {};
      filterList.forEach((list) => {
        filters[list.name] = "";
      });
      return filters;
    });
    setTotalPage(() => 0);
    setCurrentPage(() => 1);
    setRow(() => []);
  };

  useEffect(() => {
    if (isMounted.current) getList();
    isMounted.current = true;
  }, [currentPage]);
  const validateDownload = (filter) => {
    if (!filter?.from_date || !filter?.to_date) {
      Swal.fire("Error", "Date is Required");
      return false;
    }

    return true;
  };

  const changePageSize = (e) => {
    const newSize = e.target.value;
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (row.length > 0) {
      getList();
    }
  }, [pageSize]);
  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />
          <main className="bg-white rounded-2" id="ledger">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col-md">
                  <Breadcrumb path={["Non Moving Item"]} />
                </div>

                <div className="col-md text-end">
                  <select value={pageSize} onChange={(e) => changePageSize(e)}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <Tippy content="Filter" trigger="mouseenter">
                    <img
                      src={filterIcon}
                      className="img-fluid mx-2 icon"
                      width="35px"
                      height="35px"
                      alt=""
                      role="button"
                      onClick={(e) => setShowFilter(!showFilter)}
                    />
                  </Tippy>

                  <ExcelDownload
                    validate={validateDownload}
                    filter={filter}
                    filename="Non Moving Items"
                    url={`${config.apiUrl}/report/listNonMovingItems`}
                  />
                </div>
              </div>

              <Filter
                show={showFilter}
                filterList={filterList}
                showLoading={showLoading}
                handler={{ getList, clearList, state: { filter, setFilter } }}
              />

              <Table tableData={{ column, row }} handler={{ getList }} />
              <div className="row mt-4">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / Number(pageSize))}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};
export default NonMovingItems;
